import React from 'react';
import MuiAvatar, { AvatarProps } from '@mui/material/Avatar';
import { makeStyles } from 'tss-react/mui';

interface IProps extends Omit<AvatarProps, 'ref'> {
  disabled?: boolean;
}

const useStyles = makeStyles()({
  disabled: {
    opacity: 0.26,
  },
});

/**
 * Avatar är en färgad cirkulär bakgrund, ovanpå denna kan en ikon eller bild visas.
Används I nuläget bara för användaren. En avatar kan vara en ikon eller en beskuren bild som symboliserar en person eller entitet. Avatar bör användas oerhört sparsamt, för att inte förvirra användaren.
 */
export const EDAvatar = React.forwardRef<HTMLDivElement, IProps>(
  (props, ref) => {
    const { disabled, className, ...muiProps } = props;
    const { classes, cx } = useStyles();
    return (
      <MuiAvatar
        {...muiProps}
        ref={ref}
        className={cx(className, { [classes.disabled]: disabled })}
      />
    );
  }
);

export default EDAvatar;
